import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSlider from './components/ProductSlider';
import Kurumsal from './components/Kurumsal';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <ProductSlider />
      <Kurumsal />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;